import { Component, input, model, output } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface FilterTabOption {
  label: string;
  value: unknown;
}

@Component({
  selector: 'lepi-filter-tab',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex gap-1.5" role="tablist">
      @for (tab of options(); track tab.value) {
        <button
          type="button"
          class="cursor-pointer px-4 py-1.5 rounded-full text-sm font-medium transition-all duration-200 shrink-0 select-none"
          [class.bg-primary/10]="value() === tab.value"
          [class.text-primary]="value() === tab.value"
          [class.font-semibold]="value() === tab.value"
          [class.text-base-content/40]="value() !== tab.value"
          [class.hover:text-base-content/70]="value() !== tab.value"
          [class.hover:bg-base-200/50]="value() !== tab.value"
          (click)="handleValueChange(tab.value)">
          {{ tab.label }}
        </button>
      }
    </div>
  `,
})
export class FilterTabComponent {
  options = input.required<FilterTabOption[]>();
  value = model<unknown>();
  tabChange = output<unknown>();

  handleValueChange(newValue: unknown) {
    this.value.set(newValue);
    this.tabChange.emit(newValue);
  }
}
